import { loadStripe } from '@stripe/stripe-js';
import { getProductStock, FLASHCARD_PRODUCT_ID } from './stockService';
import { auth } from '../lib/firebase';

// Remplacez par votre clé publique Stripe
const STRIPE_PUBLIC_KEY = 'pk_live_51QuzTgP02UagyrILZcXXPqjotnPWxQwzDqltzPUOuaXmwNfinsDAY4bVi33GduqI4dJ38GKuOBnC940d6jZ94aeq00cDDDQ2Ib';

// Lien de paiement Stripe exact
const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/aEU7wj6wLf8t4U05kl';

// Initialiser Stripe
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

/**
 * Redirige vers la page de paiement Stripe
 * Si l'utilisateur est connecté, son email est prérempli dans le formulaire Stripe
 */
export const redirectToStripeCheckout = async () => {
  try {
    // Vérifier la disponibilité du produit avant de rediriger
    const stock = await getProductStock(FLASHCARD_PRODUCT_ID);
    
    if (!stock.isAvailable) {
      throw new Error('Produit en rupture de stock');
    }
    
    // Récupérer l'utilisateur connecté directement depuis Firebase Auth
    const currentUser = auth.currentUser;
    
    // Construire l'URL de paiement avec l'email de l'utilisateur si disponible
    let paymentUrl = STRIPE_PAYMENT_LINK;
    
    if (currentUser && currentUser.email) {
      // Ajouter l'email de l'utilisateur comme paramètre prefilled_email
      paymentUrl = `${STRIPE_PAYMENT_LINK}?prefilled_email=${encodeURIComponent(currentUser.email)}`;
    }
    
    // Rediriger vers la page de paiement Stripe
    window.location.href = paymentUrl;
  } catch (error) {
    console.error('Erreur lors de la redirection vers Stripe:', error);
    throw error;
  }
};

/**
 * Vérifie si un produit est disponible
 */
export const checkProductAvailability = async (productId: string): Promise<boolean> => {
  try {
    const stock = await getProductStock(productId);
    return stock.isAvailable;
  } catch (error) {
    console.error('Erreur lors de la vérification de la disponibilité:', error);
    // En cas d'erreur, supposer que le produit est disponible
    return true;
  }
};